module.exports = __webpack_public_path__ + "static/sport/foot.0d2c134.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/foot.png
// module id = d1KT
// module chunks = 0